import clsx from "clsx";
import type { ReactNode } from "react";

const bgColorClasses =
  "first:bg-slightbeige nth-2:bg-slightbeige-104 nth-3:bg-slightbeige-108 nth-4:bg-slightbeige-112 nth-5:bg-slightbeige-116 nth-6:bg-slightbeige-120 nth-7:bg-slightbeige-124";

export default function MenuLayoutGroup({
  isMobile,
  children,
  textColor,
  bgColor,
}: {
  isMobile: boolean;
  children: ReactNode;
  textColor?: string;
  bgColor?: string;
}) {
  return (
    <div
      className={clsx(bgColor ?? bgColorClasses, "w-full shrink-0", {
        "md:w-[220px] md:min-w-[200px]": !isMobile,
      })}
    >
      <div
        className={clsx("flex flex-col", {
          "gap-[24px] px-[22px] pt-[30px] pb-[20px]": !isMobile,
          color: textColor,
        })}
      >
        {children}
      </div>
    </div>
  );
}
